/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PhoneSignInCheckInput = {|
  leadId?: ?string,
  developmentRegistrationFormId?: ?string,
  number?: ?string,
  code?: ?string,
  primary?: ?boolean,
  clientMutationId?: ?string,
|};
export type phoneVerificationCheckMutationVariables = {|
  input: PhoneSignInCheckInput
|};
export type phoneVerificationCheckMutationResponse = {|
  +phoneSignInCheck: ?{|
    +errors: ?{|
      +code: ?string
    |}
  |}
|};
export type phoneVerificationCheckMutation = {|
  variables: phoneVerificationCheckMutationVariables,
  response: phoneVerificationCheckMutationResponse,
|};
*/


/*
mutation phoneVerificationCheckMutation(
  $input: PhoneSignInCheckInput!
) {
  phoneSignInCheck(input: $input) {
    errors {
      code
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PhoneSignInCheckPayload",
    "kind": "LinkedField",
    "name": "phoneSignInCheck",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhoneSignInCheckErrors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "phoneVerificationCheckMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "phoneVerificationCheckMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ce2d40069b5dcdfd1d4d7f585d527440",
    "id": null,
    "metadata": {},
    "name": "phoneVerificationCheckMutation",
    "operationKind": "mutation",
    "text": "mutation phoneVerificationCheckMutation(\n  $input: PhoneSignInCheckInput!\n) {\n  phoneSignInCheck(input: $input) {\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e38cc46757f4e0ba59118be0ce2acc5';

export default node;
